import React from "react";
import { useTranslation } from "react-i18next";

const LoaderProgressBar = ({
  progress = 11,
  steps = 3,
  loaderHeading,
  loaderSubheading,
  analyzingPlan,
  type,
  currentSlide,
}) => {

  const rules = {
    sleep: {
      full: 100,
      second: 20,
      first: 10,
    },
    mindfulness: {
      full: 100,
      second: 32,
      first: 16,
    },
    quiz: {
      full: 100,
      second: 20,
      first: 10,
    },
    motivation:{
      full: 100,
      second: 14,
      first: 7,
    }
  };

  const getIsFilled = (progress, stepNumber, type) => {
    const rule = rules[type];

    if (!rule) return false; // fallback

    if (progress === rule.full) {
      return true;
    } else if (progress > rule.second) {
      return stepNumber <= 2;
    } else if (progress > rule.first) {
      return stepNumber <= 1;
    }

    return false;
  };

  const percentPerStep = 100 / steps;
  const { t } = useTranslation();
  return (
    <div className="w-full">
      <div className="flex items-center justify-between my-3">
        <h3 className="text-[#fff] font-[600] text-[20px]">{loaderHeading}</h3>
        <div
          className="p-3 flex items-center justify-center block md:hidden"
          style={{
            background: "linear-gradient(180deg, #0771EF 0%, #15AAFC 100%)",
            borderRadius: "50%",
            width: "32px",
            height: "32px",
          }}
        >
          <span className="!text-[11px] text-white text-sm">
            {progress.toFixed(0)}%
          </span>
        </div>
      </div>

      <div className="flex items-center justify-between my-3">
        <p className="text-[#fff] text-sm">
          {/* {progress > 80
            ? analyzingPlan?.[analyzingPlan?.length - 1]?.analyzingPlan
            : analyzingPlan?.[currentSlide]?.analyzingPlan} */}
          {progress > rules?.[type]?.second
            ? analyzingPlan?.[2]?.analyzingPlan
            : progress > rules?.[type]?.first
            ? analyzingPlan?.[1]?.analyzingPlan
            : analyzingPlan?.[0]?.analyzingPlan}
        </p>
        {/* <span className="text-[#fff] text-sm hidden md:block">
          {progress.toFixed(0)}%
        </span> */}
      </div>

      <div className="flex w-full h-[22px] gap-[2px] overflow-hidden bg-white p-1 rounded-[9px]">
        {[...Array(steps)].map((_, i) => {
          const stepNumber = i + 1;

          const isFilled = getIsFilled(progress, stepNumber, type);

          return (
            <div
              key={i}
              className="h-full rounded-[9px] relative"
              style={{
                width: `${100 / steps}%`,
                backgroundColor: isFilled ? "transparent" : "#E6E6E6",
              }}
            >
              {isFilled && (
                <div
                  className="absolute top-0 left-0 h-full rounded-[9px] w-full"
                  style={{
                    background:
                      "linear-gradient(180deg, #0771EF 0%, #15AAFC 100%)",
                  }}
                ></div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LoaderProgressBar;
